import initGalleries from '@resources/js/components/galleries'
import inViewport from '@resources/js/helpers/inViewport'

inViewport('.js-extra-hotel', initGalleries)

